import { IAppState } from '../../redux';
import { IGeoAddress } from '../../redux/reducers';

/**
 *
 * @description Массив address хранит гео в порядке ParentToChild (от наиболее общего гео к конкретному).
 * Например [регион, район, дом]. Данный селектор вернет последний элемент.
 */
export function selectGeoChildLocation(state: IAppState): IGeoAddress | null {
  const {
    offer: { geo },
  } = state;

  const address = geo?.address || [];

  return address[address.length - 1] || null;
}
